import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography
} from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { muiTheme } from 'mui-theme'

interface PasswordOutcome {
  invalid: boolean
  message: string
}

export const PasswordRules: React.FC<{
  passwordOutcome: PasswordOutcome[]
}> = ({ passwordOutcome }) => (
  <Box sx={{ textAlign: 'left' }}>
    <Typography variant="body1">
      Please choose a password that meets all of the following criteria:
    </Typography>
    <List component={Stack} spacing={0.5} sx={{ p: 0, pt: 1 }}>
      {passwordOutcome.map(({ invalid, message }) => {
        const icon = invalid ? 'close' : 'circleCheck'
        const paletteColor = invalid
          ? muiTheme.palette.grey[500]
          : muiTheme.palette.primary.main

        return (
          <ListItem
            key={message}
            disablePadding
            alignItems="center"
            component={Stack}
            direction="row"
          >
            <ListItemIcon
              sx={(muiTheme) => ({ minWidth: 24, mr: muiTheme.spacing(1) })}
            >
              <Stack
                direction="row"
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <Icon css={{ color: paletteColor }} icon={icon} />
              </Stack>
            </ListItemIcon>
            <ListItemText sx={{ my: 0 }}>
              <Typography sx={{ color: paletteColor }} variant="body2">
                {message}
              </Typography>
            </ListItemText>
          </ListItem>
        )
      })}
    </List>
  </Box>
)
